export const messages = {
  no_navigation: {
    defaultMessage: 'No InPage Navigation content provided',
    id: 'ui.in-page-navigation.no-navigation-content',
  },
  show_additional_navigation_items: {
    defaultMessage: 'Show additional navigation items',
    id: 'ui.in-page-navigation.show-additional-navigation-items',
  },
  hide_additional_navigation_items: {
    defaultMessage: 'Hide additional navigation items',
    id: 'ui.in-page-navigation.hide-additional-navigation-items',
  },
};
